import React from "react";

import { Paper } from "../api/S2PublicApiProxy";

export const PaperLink = ({ paper }: {paper: Paper}) => {
  const mkPaperUrl = (paper: Paper) => `https://www.semanticscholar.org/paper/${paper.paperId}`;

  return <div><a href={mkPaperUrl(paper)} target="_blank">{paper.title}</a></div>;
}
